(() => {
  if (location.hash === '#ProductSizing') {
    requestAnimationFrame(() => document.querySelector('[data-size-open]')?.click());
  }

  const desktop = matchMedia('(min-width: 750px)');
  document.querySelectorAll('.kk-card__size-tools').forEach(tools => {
    const card = tools.closest('[data-product-card]');
    if (!card) return;

    const openForPointerOrFocus = () => {
      if (desktop.matches) tools.open = true;
    };
    const closeAfterExit = event => {
      if (desktop.matches && !card.contains(event.relatedTarget) && !card.contains(document.activeElement)) {
        tools.open = false;
      }
    };

    card.addEventListener('pointerenter', openForPointerOrFocus);
    card.addEventListener('pointerleave', closeAfterExit);
    card.addEventListener('focusin', openForPointerOrFocus);
    card.addEventListener('focusout', closeAfterExit);
  });
})();
